"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('.leasing-btn a');

  for (var i = 0; i < links.length; i += 1) {
    links[i].setAttribute('data-lity-close', '');
  }
});